<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.group-person-count {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.group-creation-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
}

button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
.option-inner-wrap {
  margin: 0;
  padding: 0;
}
.option-inner-wrap li {
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

#page-user-list .ag-header-cell,
#page-user-list .ag-cell {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
#page-user-list .freez-action-col {
  padding-left: 10px;
}
.header-custome span {
  font-size: 15px;
}
.popup-single-upload-right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.info-option-wrapper {
  line-height: 0;
  margin-right: 10px;
  position: relative;
}
.popup-info-tooltips {
  position: absolute;
  right: 0;
  z-index: 999;
  background: #fff;
  padding: 10px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 421px;
  height: 270px;
  overflow: hidden;
  top: 100%;
  z-index: 99999;
}
.popup-info-tooltips img {
  max-width: 100%;
}
.popup-info-tooltips {
  display: none;
}
.info-option-wrapper:hover .popup-info-tooltips {
  display: flex;
}
.popup-info-tooltips.info-top-custom-tooltip {
  top: -280px !important;
  right: 0;
}

.blank-attendee {
  height: 732px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.entity-create-sec {
  text-align: center;
}
.entity-setup-buttons button {
  margin: 25px 7px 0;
}
.new-entity-add-button {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
.emtity-icon span svg {
  display: inline-block;
  height: 100px;
  width: 100px;
}
.emtity-icon {
  height: 200px;
  width: 290px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  overflow: hidden;
}
.emtity-icon img {
  max-width: 100%;
  height: 100%;
}
.entity-create-desc p {
  width: 480px;
  margin: 0 auto;
}
.knowlg-base-wrap-sec span {
  display: inline-block;
  background: #fff;
  padding: 5px 8px;
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>
        Round Tables
        <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows + ")" : ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec">
        <span class="ml-3 text-default h3"
          >Total Round Tables: {{ roundtableData.length }}</span
        >
        <span class="ml-3 text-success h3"
          >Open Tables: {{ roundtableDataObj.openTables }}</span
        >
        <span class="ml-3 text-success h3"
          >Pre-Assigned: {{ roundtableDataObj.preAssignedTables }}</span
        >
      </div>
    </div>
    <div class="vx-card p-6 blank-attendee" v-show="roundtableData.length < 1">
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <!--<feather-icon class="" icon="CircleIcon" />-->
          <img src="../../assets/images/blank-page-images/roundtable.png" />
        </div>
        <div class="entity-create-desc">
          <h2>Create Round Tables</h2>
          <p>
            Set up and access Round tables and boost virtual networking at your
            event. The recommended max capacity for a web roundtable is 8, and
            the Zoom option gives upto 1000(subject to license add-ons)
          </p>
          <div class="entity-setup-buttons">
            <vs-button color="primary" type="border" @click="getDefaultSettings"
              >ADVANCED SETTINGS</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="$router.push('/event/roundtable/add')"
              >ADD NEW ROUNDTABLE</vs-button
            >
            <vs-button
              color="primary"
              type="border"
              class="new-entity-add-button"
              @click="popupActive = true"
              >IMPORT ROUNDTABLES</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card p-6" v-show="roundtableData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  roundtableData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : roundtableData.length
                }}
                of {{ roundtableData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Attendee-->
        <!-- <vs-button type="border mr-4" v-on:click="ManageTopics()"
          >Manage Group(s)</vs-button
        > -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <vs-button
            type="border"
            class="mr-2 flex items-center session-create-button"
          >
            Manage</vs-button
          >
          <vs-dropdown-menu class="py-3">
            <vs-dropdown-item @click="ManageTopics()">
              <span class="flex items-center">
                <feather-icon
                  icon="ListIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Groups</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item
              @click="$router.push('/event/roundtable/seating/')"
            >
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Seating</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button
          class="mr-4"
          color="rgb(76, 139, 246)"
          type="filled"
          v-on:click="addRecord()"
          >Add Table</vs-button
        >
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          "
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer" id="dropdown-1">
          <div
            class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            "
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon
                  icon="CheckCircleIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Make Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon
                  icon="XCircleIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Make InActive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Export as CSV List</span>
              </span>
            </vs-dropdown-item>

            <!-- <vs-dropdown-item @click="OpenroundtableExport">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Download Report(s)</span>
              </span>
            </vs-dropdown-item> -->

            <vs-dropdown-item @click="OpenPreAssignedExport()">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Pre-assigned Table Status Report</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="OpenAutoFlowRoundtableExport">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Roundtable Reports</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="rtEndCall('rt')">
              <span class="flex items-center">
                <feather-icon
                  icon="PhoneOffIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Forcefully end Active Tables</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="deleteRecord()">
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete Table(s)</span>
              </span>
            </vs-dropdown-item>
            <!--
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>
            -->
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button
          color="primary"
          type="border"
          class="ml-3"
          @click="popupActive = true"
          >Import</vs-button
        >
        <vs-popup
          class="holamundo"
          title="Import Round Table"
          :active.sync="popupActive"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4>Download the template</h4>
              <a
                color="primary"
                type="filled"
                class="mt-3 btn"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_RoundTable.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
                >Download</a
              >
            </div>
            <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
            <div class="upload-file mt-5">
              <h4>Upload your file</h4>
              <div class="file-up-section">
                <p>Select XLSX file</p>
                <input
                  type="file"
                  id="roundtable_file"
                  accept=".csv,.xlsx,.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <vs-button
                  color="rgb(76, 139, 246)"
                  type="filled"
                  class="sub-btn"
                  v-on:click="UploadRoundTable"
                  >Upload</vs-button
                >
              </div>
            </div>
          </div>
        </vs-popup>
        <vs-button
          color="primary"
          type="border"
          class="ml-3 setting-btn"
          @click="getSettings"
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>
        <!-- Export Popup -->

        <vs-popup
          class="holamundo"
          title="Export Roundtable"
          :active.sync="popupActiveExport"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4 id="modalRoundtableSelected">Roundtable Selected : 0</h4>
              <br />
              <hr />
            </div>
            <br />
            <div class="upload-file mt-5">
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="getParticipanceData"
                >Attendance</vs-button
              >&nbsp;
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="getroundTableChats"
                >Chats</vs-button
              >&nbsp;
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="DownloadQnAData"
                >QnA</vs-button
              >
            </div>
          </div>
        </vs-popup>

        <vs-popup
          class="holamundo"
          title="Export Pre-assigned Table Status Report"
          :active.sync="popupPreAssignedExport"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4 id="modalRoundtablePreAssignedSelected">
                Roundtable Selected : 0
              </h4>
              <br />
              <hr />
            </div>
            <br />
            <div class="upload-file mt-5">
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="downloadTheCvsFile"
                >Download CSV</vs-button
              >&nbsp;
            </div>
          </div>
        </vs-popup>

        <!-- Export popup ends -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="roundtableData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <!-- Round table Topic-->
    <vs-popup
      class="holamundo"
      title="Group List"
      :active.sync="popupActiveTopic"
    >
      <!-- <div class="vx-col w-full text-right mb-5">
        <vs-button color="success" type="gradient" @click="addCategory()"
          >Add Category</vs-button
        >
      </div> -->

      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <div class="vx-col w-full text-right mb-5">
            <vs-button color="success" type="gradient" @click="addTopic()"
              >Add Group</vs-button
            >

            <vs-button class="ml-5" type="border" @click="rtEndCall('topic')"
              >End Call</vs-button
            >
          </div>

          <ag-grid-vue
            ref="agGridTopicList"
            :components="components"
            @gridReady="onGridReadyTopic($event)"
            :gridOptions="gridOptionsTopic"
            class="ag-theme-material w-full my-4 ag-grid-table"
            :columnDefs="columnDefsTopics"
            :defaultColDef="defaultColDefTopics"
            :rowData="TopicList"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="true"
            :pagination="true"
            :paginationPageSize="paginationPageSizeCategory"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
          ></ag-grid-vue>
          <!-- <vs-pagination
            :total="totalPagesCategory"
            :max="7"
            v-model="currentPageCategory"
          /> -->
          <!-- AG GRID CAtegory Ends-->
        </div>
      </div>
    </vs-popup>
    <!-- Exhibitor Category Ends-->
    <!-- Roundtable Add Topic -->
    <vs-popup
      class="holamundo"
      title="Add New Group"
      :active.sync="popupActiveAddTopic"
    >
      <div class="vx-col w-full text-right"></div>
      <!-- <div class="add-track-inner-section"> -->
      <!-- <vs-select
        v-model="tableCapacity"
        class="w-full select-large"
        label="Table Capacity"
      >
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item, index) in TableCapacityOptions"
          class="w-full"
        />
      </vs-select> -->
      <div class="w-full group-creation-wrapper">
        <label>Group Name </label>
        <vs-input
          class="inputx input-track-name w-full mb-3"
          v-model="TopicName"
        />
        <div class="group-person-count">
          <label class="mr-5">No of Seats </label>
          <vs-input-number
            class="select-large mb-3"
            name="CountDownTime"
            v-model="tableCapacity"
            v-validate="'required'"
            :min="2"
            :max="300"
          />
        </div>
      </div>
      <div align="right">
        <vs-button color="rgb(76, 139, 246)" type="filled" @click="addTopicindb"
          >Add Group</vs-button
        >
      </div>
      <!-- </div> -->
    </vs-popup>
    <!-- Roundtable Add Topic Ends-->
    <vs-popup
      class="holamundo"
      title="Export Roundtable Report"
      :active.sync="popupActiveAutoFlowExport"
    >
      <div class="import-attendee-wrapper">
        <div class="template-download">
          <h4 id="modalAutoflowSessionsSelected">Roundtable Selected : 0</h4>
          <br />
          <hr />
        </div>
        <br />
        <div class="upload-file mt-5">
          <vs-button
            color="rgb(76, 139, 246)"
            type="filled"
            class="sub-btn"
            v-on:click="getRoundtableAutoflowAttendance()"
            >Roundtable Attendance</vs-button
          >&nbsp;
          <vs-button
            color="rgb(76, 139, 246)"
            type="filled"
            class="sub-btn"
            v-on:click="downloadAutoFlowChatReport"
            >Roundtable Chats</vs-button
          >&nbsp;

          <vs-button
            color="rgb(76, 139, 246)"
            type="filled"
            class="sub-btn mt-3"
            v-on:click="downloadZoomReport"
            >Zoom Analytics</vs-button
          >
          <!--<vs-button type="gradient" class="sub-btn" v-on:click="DownloadSessionQnA">Session QnA</vs-button> -->
        </div>
      </div>
    </vs-popup>
    <div v-if="popupActive2 == true">
      <rt-settings
        :data="popupActive2"
        :key="roundtableSettingsResetKey"
        v-on:saveRoundtableSettingsData="saveRoundtableSettingsData"
      />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";
// Store Module
import moduleRoundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import moduleAnalytics from "@/store/analytics/moduleAnalytics.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import RtSettings from "./RoundtableSettings.vue";
// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import ParticipantViewCellRendererActions from "./cell-renderer/ParticipantViewCellRendererActions.vue";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import parser from "ua-parser-js";
//console.log(db);
//const event_collectionName = 'sayek-dev';
import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";
import Swal from "sweetalert2";
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");

var self;
export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    ParticipantViewCellRendererActions,
    RtSettings,
  },
  data() {
    return {
      gridSelectedRows: 0,
      tableCapacity: "2",
      TableCapacityOptions: [
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
        { text: "9", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
      ],
      allAttendeeList: [],
      zoomAnalytics: [],
      popupActiveAutoFlowExport: false,
      popupActiveAddTopic: false,
      popupActiveExport: false,
      IsDefaultSettings: false,
      pageLoaded: false,
      settingsData: { IsAttendeeCreateTableEnabled: false },
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      roundtableSettingsResetKey: 0,
      // AgGrid
      gridApi: null,
      gridTopicApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      popupActiveTopic: false,
      TopicList: [],
      defaultColDefTopics: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      gridOptionsTopics: {},
      columnDefs: [
        {
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          filter: false,
          width: 50,
          pinned: "left",
        },
        {
          headerName: "Table Id",
          field: "TableId",
          hide: true,
          //width: 50,
          filter: false,
          pinned: "left",
        },
        {
          headerName: "Table Name",
          field: "TableName",
          width: 200,
          filter: true,
          pinned: "left",
        },
        {
          headerName: "Type",
          //field: "PreAssigned",
          width: 120,
          cellRenderer: (params) => {
            return params.data.PreAssigned
              ? `Pre Assigned (${params.data.StreamingClient})`
              : `Open (${params.data.StreamingClient})`;
          },
          filter: true,
        },
        /*{
          headerName: "Streaming Client",
          field: "StreamingClient",
          filter: true,
          width: 180,
          cellRenderer: (data) => {
            return data.value ? data.value : "Web";
          },
        },*/
        {
          headerName: "Group Name",
          field: "Topic.TopicName",
          width: 120,
          filter: true,
        },
        {
          //headerName: "Occupants / Seats",
          headerName: "Seats",
          field: "Capacity",
          width: 100,
          cellStyle: { "text-align": "center" },
          cellRenderer: (params) => {
            return params.data.Capacity;
            //return params.data.Occupied + "/" + params.data.Capacity;
          },
          filter: true,
        },
        {
          headerName: "Host Name",
          //field: 'Host[0].Name',
          cellRenderer: (params) => {
            //console.log(params.data.Host[0].Name)
            return params.data.Host.length ? params.data.Host[0].Name : "";
          },
          filter: true,
        },
        {
          headerName: "Creation Date and Time	",
          field: "CreatedDate",
          cellRenderer: (data) => {
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
        },
        //{
        //  headerName: "Published",
        //  field: "IsPublished",
        //  filter: true,
        //  width: 150,
        //  cellRendererFramework: "CellRendererStatus"
        //},
        {
          headerName: "Status",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererStatus",
          cellRendererParams: (params) => {
            return { id: params.data.TableId };
          },
        },
        {
          headerName: "Details",
          field: "Total",
          filter: false,
          width: 350,
          cellRendererFramework: "ParticipantViewCellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.TableId, name: params.data.TableName };
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.TableId };
          },
          pinned: "right",
        },
      ],
      columnDefsTopics: [
        {
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          filter: false,
          width: 50,
          pinned: "left",
        },
        {
          headerName: "Group Name",
          field: "TopicName",
          filter: true,
          width: 300,
        },
        {
          headerName: "Table Capacity",
          field: "TopicTableCapacity",
          filter: false,
          width: 300,
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        ParticipantViewCellRendererActions,
      },
      popupPreAssignedExport: false,
      participants: {},
      loggedInUserData: [],
    };
  },
  watch: {},
  computed: {
    roundtableData() {
      //console.log(this.$store.state.roundtableManagement.roundtables);
      return this.$store.state.roundtableManagement.roundtables;
    },
    roundtableDataObj() {
      let tableObj = {
        openTables: 0,
        preAssignedTables: 0,
      };
      this.$store.state.roundtableManagement.roundtables.forEach((item) => {
        tableObj.openTables += !item.PreAssigned ? 1 : 0;
        tableObj.preAssignedTables += item.PreAssigned ? 1 : 0;
      });
      return tableObj;
    },
    /*usersData () {
      return this.$store.state.userManagement.users
    },*/
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },

  methods: {
    addTopicindb() {
      /* eslint-disable */
      if (!this.TopicName) return;

      this.$vs.loading();
      this.$store
        .dispatch("roundtableManagement/addRoundtableTopic", {
          TopicName: this.TopicName,
          TableCapacity: this.tableCapacity,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Round Table Topic",
            text: res.message,
          });
          this.$vs.loading.close();
          if (res.status == 200) {
            this.TopicName = "";
            this.popupActiveTopic = true;
            this.popupActiveAddTopic = false;
            this.fetchTopics();
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    addTopic: function () {
      this.errors.clear();
      this.popupActiveTopic = false;
      this.popupActiveAddTopic = true;
    },
    OpenAutoFlowRoundtableExport() {
      debugger;
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 0) {
        if (selectedRows.length > 10) {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            title: "Download AutoFlow Session Reports",
            text: "Please Download one report at a time. ",
            acceptText: "OK",
          });
        } else {
          this.allAttendeeList = [];
          this.getAttendees();
          this.popupActiveAutoFlowExport = true;
          document.getElementById("modalAutoflowSessionsSelected").innerText =
            "Roundtable(s) Selected : " + selectedRows.length;
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download AutoFlow Session Reports",
          text: "Please select atleast one session to download. ",
          acceptText: "OK",
        });
      }
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        for (let i = 0; i < res.length; i++) {
          this.allAttendeeList.push({
            AttendeeId: res[i].AttendeeId,
            Company: res[i].Company,
            Designation: res[i].Designation,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone,
            ProfilePictureURL: res[i].ProfilePictureURL,
          });
        }
      });
    },
    getRoundtableAutoflowAttendance: function () {
      debugger;
      //  if (selectedRows.length > 0) {
      //         if (selectedRows.length > 10) {
      //  this.$vs.dialog({
      //     type: "alert",
      //     color: "warning",
      //     title: "Download AutoFlow Session Reports",
      //     text: "Please Download one report at a time. ",
      //     //accept: this.deleteRecord,
      //     acceptText: "OK",
      //   });
      //         }
      //  }

      //  this.allAttendeeList = [];
      let selectedRows;
      debugger;
      selectedRows = this.gridApi.getSelectedRows();
      // console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$vs.loading();

      selectedRows.map((row) => {
        var datarow = [];
        var datarow1 = [];
        var datarow2 = [];
        var datarow3 = [];
        var datarow4 = [];
        var datarow5 = [];
        var timeZone = [];

        datarow.push("Attendee Report");
        timeZone.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"' + timezone + " Time Zone" + '"');

        //----------------------------------------
        datarow1.push("ID");
        datarow1.push("Table Name");
        datarow1.push("Type");
        datarow1.push("Created On");
        datarow1.push("Total Attendees");
        if (row.PreAssigned) {
          datarow1.push("Attended this Roundtable");
        }
        //---------------------------------------------
        datarow2.push("Host/SpeakersAttendance");
        var HostOrSpeakerData = [];
        HostOrSpeakerData.push(datarow2);
        //--------------------------------------
        datarow3.push("Attended");
        datarow3.push("User Name");
        datarow3.push("Email");
        datarow3.push("Company");
        datarow3.push("Join Time");
        datarow3.push("Leave Time");
        datarow3.push("Device Info");
        datarow3.push("Country/RegionName");
        var HostOrSpeakerDetailsData = [];
        HostOrSpeakerDetailsData.push(datarow3);
        //------------------------------------------
        datarow4.push("AudienceAttendance");
        var AudianceAttendance = [];
        AudianceAttendance.push(datarow4);
        //------------------------------------------
        datarow5.push("Attended");
        datarow5.push("Name");
        // datarow5.push("LastName");
        datarow5.push("Email");
        datarow5.push("Company");
        datarow5.push("JoinTime");
        datarow5.push("LeaveTime");
        datarow5.push("Device Info");
        datarow5.push("Country/RegionName");
        var AudianceAttendanceDetails = [];
        AudianceAttendanceDetails.push(datarow5);
        //-----------------------------------------------------
        var AttendeeData = [];
        AttendeeData.push(datarow);
        var TimeZoneHeader = [];
        TimeZoneHeader.push(timeZone);

        var RoundtableData = [];
        RoundtableData.push(datarow1);
        //-------------------------------------------------------
        datarow = [];
        var text = "Report Generated:";
        datarow.push(text);
        var currentDate = new Date();
        var formatedDate =
          currentDate.toLocaleString("default", {
            month: "short",
          }) +
          " " +
          currentDate.getDate() +
          "," +
          currentDate.getFullYear() +
          " " +
          currentDate.getHours() +
          ":" +
          currentDate.getMinutes();
        datarow.push(
          '"' +
            formatedDate
              .replace(",", "")
              .replace(",", "")
              .replace(",", "")
              .replace(",", "") +
            '"'
        );
        AttendeeData.push(datarow);

        //-----------------------------------------------------------
        console.log("row=====", row);
        datarow1 = [];
        //pushing data for the Roundtable section
        var roundtableId = row.TableId == undefined ? "" : row.TableId;
        datarow1.push('"' + roundtableId + '"');

        var roundtableName = row.TableName == undefined ? "" : row.TableName;
        datarow1.push('"' + roundtableName + '"');

        var roundtableType = row.PreAssigned ? "Pre Assigned" : "Open";
        datarow1.push('"' + roundtableType + '"');

        /*var roundtableCreatedTime =
          row.CreatedDate == undefined
            ? ""
            : '"' +
              this.getFormattedDateForExport(row.CreatedDate.seconds) +
              '"' +
              " " +
              this.getFormattedTimeForExport(row.CreatedDate.seconds);*/

        var roundtableCreatedTime =
          row.CreatedDate == undefined
            ? ""
            : this.SetTimeByZone(
                new Date(row.CreatedDate.seconds * 1000).toUTCString(),
                Session_Event_TZ
              );

        datarow1.push(
          roundtableCreatedTime
            .replace(",", "")
            .replace(",", "")
            .replace(",", "")
            .replace(",", "")
        );

        debugger;
        var TotAttendee = "0";
        var totJoined = 0;
        //----Participants section-----------------------------------
        var listCompletedFlg = false;
        var participantsList = [];
        con.eventDB
          .collection(cn)
          .doc("RoundTableList")
          .collection("RoundTables")
          .doc(row.TableId)
          .collection("Participances")
          .get()
          .then((querySnapshot) => {
            var datarow = [];

            // var Localparticipance = [];
            //    participantsList.push(datarow);

            querySnapshot.forEach((doc) => {
              participantsList.push(doc.data());
            });
            //total attendee----

            if (row.PreAssigned) {
              TotAttendee =
                row.MappedAttendees == undefined
                  ? ""
                  : row.MappedAttendees.length + row.Host.length;
            } else {
              TotAttendee = participantsList.length;
            }
            //total attended in this roundtable----

            if (row.PreAssigned) {
              participantsList.map((row2) => {
                row.MappedAttendees.map((row1) => {
                  if (
                    (row1.AttendeeId == row2.AttendeeId &&
                      row2.IsActive == true) ||
                    (row1.AttendeeId == row2.AttendeeId &&
                      row2.LeaveTime != null)
                  ) {
                    totJoined++;
                  }
                });
                row.Host.map((row3) => {
                  if (
                    (row3.AttendeeId == row2.AttendeeId &&
                      row2.IsActive == true) ||
                    (row3.AttendeeId == row2.AttendeeId &&
                      row2.LeaveTime != null)
                  ) {
                    totJoined++;
                  }
                });
              });
              // totJoined =
              //   row.MappedAttendees == undefined
              //     ? ""
              //     : row.MappedAttendees.length;
            } else {
              totJoined = participantsList.length;
              participantsList.map((row2) => {
                row.Host.map((row3) => {
                  if (
                    (row3.AttendeeId == row2.AttendeeId &&
                      row2.IsActive == false) ||
                    (row3.AttendeeId == row2.AttendeeId &&
                      row2.LeaveTime == null &&
                      row2.IsActive == false)
                  ) {
                    totJoined--;
                  }
                });
              });
            }
            datarow1.push('"' + TotAttendee + '"');
            if (row.PreAssigned) {
              datarow1.push('"' + totJoined + '"');
            }
            debugger;
            RoundtableData.push(datarow1);
            /****************************************************************** */
            //-------------------------Host/speaker attendance---------------
            datarow3 = [];

            var Hostattended = "No";
            var joinTme = "";
            var leaveTme = "";
            var deviceInfo = "";
            row.Host.map((row11) => {
              participantsList.map((row22) => {
                if (
                  (row11.AttendeeId == row22.AttendeeId &&
                    row22.IsActive == true) ||
                  (row11.AttendeeId == row22.AttendeeId &&
                    row22.LeaveTime != null)
                ) {
                  Hostattended = "Yes";
                  /* joinTme =
                    row22.JoinTime == undefined || row22.JoinTime == null
                      ? "NA"
                      : '"' +
                        this.getFormattedDateForExport(row22.JoinTime.seconds) +
                        '"' +
                        " " +
                        this.getFormattedTimeForExport(row22.JoinTime.seconds);
                  leaveTme =
                    row22.LeaveTime == undefined || row22.LeaveTime == null
                      ? "NA"
                      : '"' +
                        this.getFormattedDateForExport(
                          row22.LeaveTime.seconds
                        ) +
                        '"' +
                        " " +
                        this.getFormattedTimeForExport(row22.LeaveTime.seconds);*/
                  joinTme =
                    row22.JoinTime == undefined || row22.JoinTime == null
                      ? "NA"
                      : this.SetTimeByZone(
                          new Date(row22.JoinTime.seconds * 1000).toUTCString(),
                          Session_Event_TZ
                        );

                  if (row22.LeaveTime == undefined || row22.LeaveTime == null) {
                    leaveTme = "NA";
                  } else if (
                    row22.LeaveTime.seconds <= row22.JoinTime.seconds
                  ) {
                    leaveTme = "NA";
                  } else {
                    leaveTme =
                      row22.LeaveTime == undefined || row22.LeaveTime == null
                        ? "NA"
                        : this.SetTimeByZone(
                            new Date(
                              row22.LeaveTime.seconds * 1000
                            ).toUTCString(),
                            Session_Event_TZ
                          );
                  }
                  deviceInfo =
                    row22.UserAgent == undefined || row22.UserAgent == null
                      ? "NA"
                      : '"' + this.getDevice(row22.UserAgent) + '"';
                }
              });
            });

            console.log("host=====", row.Host[0]);

            datarow3.push('"' + Hostattended + '"');
            //datarow3.push(row.Host[0].AttendeeId);
            datarow3.push('"' + row.Host[0].Name + '"');
            datarow3.push('"' + row.Host[0].Email + '"');
            datarow3.push('"' + row.Host[0].Company + '"');
            datarow3.push(
              joinTme
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
            );
            datarow3.push(
              leaveTme
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
            );
            datarow3.push(deviceInfo);
            datarow3.push("NA");
            debugger;
            HostOrSpeakerDetailsData.push(datarow3);

            //--------All attendee section ----------------------------------------------------------------------
            if (row.PreAssigned) {
              var cnt = 0;
              row.MappedAttendees.map((row111) => {
                var hasJoined = "No";
                var jointime = "";
                var leaveTme = "";
                var email = "";
                debugger;
                participantsList.map((row222) => {
                  debugger;
                  datarow5 = [];
                  if (
                    (row111.AttendeeId == row222.AttendeeId &&
                      row222.IsActive == true) ||
                    (row111.AttendeeId == row222.AttendeeId &&
                      row222.LeaveTime != null)
                  ) {
                    debugger;
                    hasJoined = "Yes";
                    /* jointime =
                      row222.JoinTime == undefined || row222.JoinTime == null
                        ? "NA"
                        : '"' +
                          this.getFormattedDateForExport(
                            row222.JoinTime.seconds
                          ) +
                          '"' +
                          " " +
                          this.getFormattedTimeForExport(
                            row222.JoinTime.seconds
                          );

                    leaveTme =
                      row222.LeaveTime == undefined || row222.LeaveTime == null
                        ? "NA"
                        : '"' +
                          this.getFormattedDateForExport(
                            row222.LeaveTime.seconds
                          ) +
                          '"' +
                          " " +
                          this.getFormattedTimeForExport(
                            row222.LeaveTime.seconds
                          );*/

                    jointime =
                      row222.JoinTime == undefined || row222.JoinTime == null
                        ? "NA"
                        : this.SetTimeByZone(
                            new Date(
                              row222.JoinTime.seconds * 1000
                            ).toUTCString(),
                            Session_Event_TZ
                          );

                    if (
                      row222.LeaveTime == undefined ||
                      row222.LeaveTime == null
                    ) {
                      leaveTme = "NA";
                    } else if (
                      row222.LeaveTime.seconds <= row222.JoinTime.seconds
                    ) {
                      leaveTme = "NA";
                    } else {
                      leaveTme =
                        row222.LeaveTime == undefined ||
                        row222.LeaveTime == null
                          ? "NA"
                          : this.SetTimeByZone(
                              new Date(
                                row222.LeaveTime.seconds * 1000
                              ).toUTCString(),
                              Session_Event_TZ
                            );
                    }
                    if (hasJoined == "Yes") {
                      deviceInfo =
                        row222.UserAgent == undefined ||
                        row222.UserAgent == null
                          ? "NA"
                          : '"' + this.getDevice(row222.UserAgent) + '"';
                    } else {
                      deviceInfo = "NA";
                    }
                  }
                });

                console.log("row111=====", row111);
                //             var name = row111.Name;
                // var first_name = name.split(' ')[0]
                // var last_name = name.substring(first_name.length).trim()

                datarow5.push('"' + hasJoined + '"');
                datarow5.push('"' + row111.Name + '"');
                //datarow5.push('"' + last_name + '"');
                email = row111.Email == undefined ? "" : row111.Email;
                datarow5.push('"' + email + '"');
                datarow5.push('"' + row111.Company + '"');
                datarow5.push(
                  jointime
                    .replace(",", "")
                    .replace(",", "")
                    .replace(",", "")
                    .replace(",", "")
                    .replace(",", "")
                );
                datarow5.push(
                  leaveTme
                    .replace(",", "")
                    .replace(",", "")
                    .replace(",", "")
                    .replace(",", "")
                    .replace(",", "")
                );
                if (hasJoined == "Yes") {
                  datarow5.push(deviceInfo);
                } else {
                  datarow5.push("NA");
                }
                datarow5.push("NA");
                if (AudianceAttendanceDetails[cnt].indexOf(email.trim()) < 0) {
                  cnt++;
                  AudianceAttendanceDetails.push(datarow5);
                }
              });
            } else {
              var jointime2 = "";
              var leaveTme2 = "";
              var deviceInfo2 = "";
              participantsList.map((row3) => {
                console.log("row3=====", row3);
                //                             var name1 = row3.Name;
                // var first_name1 = name1.split(' ')[0]
                // var last_name1 = name1.substring(first_name1.length).trim();

                row.Host.map((row11) => {
                  if (row11.AttendeeId != row3.AttendeeId) {
                    datarow5 = [];
                    datarow5.push("Yes");
                    datarow5.push('"' + row3.Name + '"');
                    // datarow5.push('"' + last_name1 + '"');
                    var email = "";
                    this.allAttendeeList.map((row40) => {
                      if (row40.AttendeeId == row3.AttendeeId) {
                        email = row40.Email == undefined ? "" : row40.Email;
                        datarow5.push('"' + email + '"');
                      }
                    });
                    datarow5.push('"' + row3.Company + '"');
                    /*datarow5.push(
                  row3.JoinTime == undefined || row3.JoinTime == null
                    ? "NA"
                    : '"' +
                        this.getFormattedDateForExport(row3.JoinTime.seconds) +
                        '"' +
                        " " +
                        this.getFormattedTimeForExport(row3.JoinTime.seconds)
                );
                datarow5.push(
                  row3.LeaveTime == undefined || row3.LeaveTime == null
                    ? "NA"
                    : '"' +
                        this.getFormattedDateForExport(row3.LeaveTime.seconds) +
                        '"' +
                        " " +
                        this.getFormattedTimeForExport(row3.LeaveTime.seconds)
                );*/
                    jointime2 =
                      row3.JoinTime == undefined || row3.JoinTime == null
                        ? "NA"
                        : this.SetTimeByZone(
                            new Date(
                              row3.JoinTime.seconds * 1000
                            ).toUTCString(),
                            Session_Event_TZ
                          );
                    datarow5.push('"' + jointime2 + '"');
                    // datarow5.push(
                    //   row3.JoinTime == undefined || row3.JoinTime == null
                    //     ? "NA"
                    //     : this.SetTimeByZone(
                    //         new Date(row3.JoinTime.seconds * 1000).toUTCString(),
                    //         Session_Event_TZ
                    //       )
                    // );
                    if (row3.LeaveTime == undefined || row3.LeaveTime == null) {
                      leaveTme2 = "NA";
                    } else if (
                      row3.LeaveTime.seconds <= row3.JoinTime.seconds
                    ) {
                      leaveTme2 = "NA";
                    } else {
                      leaveTme2 =
                        row3.LeaveTime == undefined || row3.LeaveTime == null
                          ? "NA"
                          : this.SetTimeByZone(
                              new Date(
                                row3.LeaveTime.seconds * 1000
                              ).toUTCString(),
                              Session_Event_TZ
                            );
                    }
                    datarow5.push('"' + leaveTme2 + '"');
                    deviceInfo2 =
                      row3.UserAgent == undefined || row3.UserAgent == null
                        ? "NA"
                        : '"' + this.getDevice(row3.UserAgent) + '"';
                    datarow5.push(deviceInfo2);
                    /*datarow5.push(
                  row3.LeaveTime == undefined || row3.LeaveTime == null
                    ? "NA"
                    : this.SetTimeByZone(
                        new Date(row3.LeaveTime.seconds * 1000).toUTCString(),
                        Session_Event_TZ
                      )
                );*/

                    datarow5.push("NA");
                    debugger;
                    AudianceAttendanceDetails.push(datarow5);
                  }
                });
              });
            }
            //-------------------------------------------------------------------------------------
            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            TimeZoneHeader.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            RoundtableData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            HostOrSpeakerData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            HostOrSpeakerDetailsData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            AudianceAttendance.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            AudianceAttendanceDetails.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            this.$vs.loading.close();
            var filename =
              "AutoFlowRoundtableReport_" + row.TableId + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);

            document.body.appendChild(link); // Required for FF
            link.click();
            /***************************************************************** */
          })
          .catch((err) => {
            this.$vs.loading.close();
            debugger;
            console.error(err);
          });
        debugger;
      });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    downloadAutoFlowChatReport: function () {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      debugger;
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      console.log(cn);

      selectedRows.map((row) => {
        con.eventDB
          .collection(cn)
          .doc("UserVideoActivity")
          .collection("RoundTable")
          .doc(row.TableId)
          .collection("Chat")
          .get()
          .then((querySnapshot) => {
            var datarow = [];
            var timeZone = [];

            timeZone.push("Report Exported In ");
            var timezone =
              Session_Event_TZ == undefined ? "" : Session_Event_TZ;
            timeZone.push('"' + timezone + " Time Zone" + '"');

            datarow.push("ChatId");
            datarow.push("Name");
            datarow.push("Message");
            datarow.push("SentTime");
            var Localparticipance = [];
            Localparticipance.push(datarow);
            var TimeZoneHeader = [];
            TimeZoneHeader.push(timeZone);

            querySnapshot.forEach((doc) => {
              datarow = [];
              var chatId =
                doc.data().ChatId == undefined ? "" : doc.data().ChatId;
              datarow.push('"' + chatId + '"');
              var userName = (
                doc.data().Name == undefined ? "" : doc.data().Name.toString()
              ).trim();
              datarow.push('"' + userName + '"');
              var Msg = (
                doc.data().Message.toString() == undefined
                  ? ""
                  : doc
                      .data()
                      .Message.toString()
                      .split("#")
                      .join("")
                      .split(",")
                      .join("")
              ).trim();
              datarow.push('"' + Msg + '"');
              var SentTime =
                doc.data().CreatedDate == undefined ||
                doc.data().CreatedDate == null
                  ? "NA"
                  : self.SetTimeByZone(
                      new Date(
                        doc.data().CreatedDate.seconds * 1000
                      ).toUTCString(),
                      Session_Event_TZ
                    );

              datarow.push(
                SentTime.replace(",", "").replace(",", "").replace(",", "")
              );
              Localparticipance.push(datarow);
            });
            let csvContent = "data:text/csv;charset=utf-8,";
            debugger;
            TimeZoneHeader.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            Localparticipance.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });

            var filename =
              "AutoFlow_Chat_" +
              "_" +
              row.TableId +
              "_" +
              row.TableName +
              ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            // link.setAttribute("id", "AutoFlow_Chat" + row.TableId);
            link.setAttribute("download", filename);
            //  this.$vs.loading.close();
            document.body.appendChild(link); // Required for FF

            link.click();
          });
      });
    },
    getFormattedDateForExport: function (seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.toLocaleString("default", { month: "short" });
      var year = dt.getFullYear();

      var formattedValue = month + ", " + day.toString() + ", " + year;
      return formattedValue;
    },
    getFormattedTimeForExport: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      var formattedValue = hours.toString() + ":" + minutes.toString() + ":";
      return formattedValue;
    },
    ManageTopics: function () {
      this.fetchTopics();
      this.popupActiveTopic = true;
    },
    fetchTopics() {
      console.log("called------");
      this.$store
        .dispatch("roundtableManagement/fetchRoundTableTopicForGrid")
        .then((res) => {
          console.log("res---", res);
          this.TopicList = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    rtEndCall(type) {
      this.popupActiveTopic = false;
      const { value: text } = Swal.fire({
        title: `Are you sure you want to end all Round Tables ${
          type == "topic" ? "in this Group" : ""
        }?`,
        text: "Note: This will kick out all from active Roundtable meetings. This feature only works on the Web Player and not Zoom meetings",
        input: "text",
        inputPlaceholder: "Type 'YES' and hit the Submit button",
        showCancelButton: true,
        confirmButtonText: "YES",
        cancelButtonText: "NO",
        inputValidator: (value) => {
          if (value.toLocaleLowerCase().trim() == "yes") {
            this.kickoffEndCall(type);
          } else {
            return "Try again! Please type 'YES' and hit Submit.";
          }
        },
      });
    },
    kickoffEndCall(type) {
      let TableIds = [];
      let TopicIds = [];
      let selectedRows;
      if (type == "rt") {
        selectedRows = this.gridApi.getSelectedRows();
        TableIds = selectedRows.map((row) => {
          return row.TableId;
        });
      } else if (type == "topic") {
        selectedRows = this.gridTopicApi.getSelectedRows();
        TopicIds = selectedRows.map((row) => {
          return row.TopicId;
        });
      }
      if (selectedRows.length > 0) {
        this.gridApi.deselectAll();
        this.gridTopicApi.deselectAll();
        this.popupActiveTopic = false;
        this.$vs.loading();
        this.$store
          .dispatch("roundtableManagement/kickoffEndCall", {
            SessionIds: [],
            TableIds: TableIds,
            TopicIds: TopicIds,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                text: "Call Ended.",
              });
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: "Call not ended!",
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$vs.notify({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "End Call",
          text: "Please select atleast one record to end call. ",
          acceptText: "OK",
        });
      }
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        //this.popupActiveExport = true;
        var datarow = [];
        var timeZone = [];
        timeZone.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"' + timezone + " Time Zone" + '"');

        datarow.push("Table Id");
        datarow.push("Table Name");
        datarow.push("Type");
        datarow.push("Max Seats");
        datarow.push("Topic Name");
        datarow.push("Spectate Mode");
        datarow.push("Host Email");
        datarow.push("Seats Pre-assigned to");
        var AttendeeData = [];
        AttendeeData.push(datarow);
        var TimeZoneHeader = [];
        TimeZoneHeader.push(timeZone);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var TableId = row.TableId == undefined ? "" : row.TableId;
          datarow.push('"' + TableId + '"');
          var TableName = row.TableName == undefined ? "" : row.TableName;
          datarow.push('"' + TableName + '"');
          var Type = row.PreAssigned ? "Pre Assigned" : "Open";
          datarow.push('"' + Type + '"');
          var Seats = row.Capacity == undefined ? "" : row.Capacity;
          datarow.push('"' + Seats + '"');
          var Topic =
            row.Topic.TopicName == "" || row.Topic.TopicName == undefined
              ? "General"
              : row.Topic.TopicName;
          datarow.push('"' + Topic + '"');
          var Spectate = row.SpectatorEnabled == "On" ? "Enable" : "Disable";
          datarow.push('"' + Spectate + '"');
          var Host = row.Host.length ? row.Host[0].Email : "";
          datarow.push('"' + Host + '"');
          if (row.PreAssigned) {
            var attendeeList = [];
            row.MappedAttendees.map((row1) => {
              var mappedAttendee =
                row1.Email == undefined || row1.Email == "" ? "" : row1.Email;
              attendeeList.push(mappedAttendee);
            });
            datarow.push('"' + attendeeList.join(",") + '"');
          }

          AttendeeData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "RoundTableExport_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one roundtable to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    OpenroundtableExport() {
      //alert("OpenSessionExport");
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      // console.log(selectedRows.length);
      if (selectedRows.length > 0) {
        if (selectedRows.length > 10) {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            title: "Download Reports",
            text: "Please Download report for upto 10 at a time. ",
            //accept: this.deleteRecord,
            acceptText: "OK",
          });
        } else {
          this.popupActiveExport = true;

          document.getElementById("modalRoundtableSelected").innerText =
            "Roundtable(s) Selected : " + selectedRows.length;
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one roundtable to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    getParticipanceData: function () {
      // var listRef = con.eventDB.collection(roundtbaleColName.toString()); //"OAUAT_1591907102804_521000_rt")
      // //  console.log(roundtbaleColName);
      // listRef.get().then(querySnapshot => {});
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      console.log(cn);

      selectedRows.map((row) => {
        console.log(row.TableId);
        con.eventDB
          .collection(cn)
          .doc("RoundTableList")
          .collection("RoundTables")
          .doc(row.TableId)
          .collection("Participances")
          .get()
          .then((querySnapshot) => {
            var datarow = [];

            datarow.push("Name");
            var Localparticipance = [];
            Localparticipance.push(datarow);

            querySnapshot.forEach((doc) => {
              datarow = [];

              var name = doc.data().Name;
              datarow.push(name.toString());

              Localparticipance.push(datarow);
            });
            let csvContent = "data:text/csv;charset=utf-8,";

            Localparticipance.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });

            var filename =
              "Participance_RT_" +
              "_" +
              row.TableName +
              "_" +
              row.TableId +
              ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
          });
      });
    },
    DownloadQnAData: function (roundtbaleColName, tableId) {
      // debugger;
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");

      selectedRows.map((row) => {
        var roundtbaleColName =
          "OAUAT_" +
          Session_Event_Id.replace("E", "").trim() +
          "_" +
          row.TableId +
          "_rt";
        console.log(roundtbaleColName);
        debugger;

        var listRef = con.eventDB.collection(roundtbaleColName.toString());

        listRef
          .get()
          .then((querySnapshot) => {
            // if (doc.exists) {
            var datarow = [];
            datarow.push("Date");
            datarow.push("Question");
            datarow.push("Name");
            //datarow.push("UserID");

            datarow.push("Votes");
            var LocalQnAData = [];
            LocalQnAData.push(datarow);

            querySnapshot.forEach((doc) => {
              if (
                doc.id != "Chats" &&
                doc.id != "BroadcastSettings" &&
                doc.id != "Attendees" &&
                doc.id != undefined
              ) {
                datarow = [];
                // debugger;
                var CreatedTime = (
                  doc.data().CreatedTime.seconds.toString() == undefined
                    ? ""
                    : self.getFormattedTime(doc.data().CreatedTime.seconds)
                )
                  .toString()
                  .trim();
                datarow.push(CreatedTime.toString());
                //------------------------------------------------------------------------------
                var Question = (
                  doc.data().Question.toString() == undefined
                    ? ""
                    : doc.data().Question.toString().split(",").join("")
                ).trim();
                datarow.push(Question.toString());
                //--------------------------------------------------------------------------------
                var UserFullName = (
                  doc.data().UserFullName.toString() == undefined
                    ? ""
                    : doc.data().UserFullName.toString()
                ).trim();
                datarow.push(UserFullName.toString());
                //--------------------------------------------------------------------------------
                var Votes = (
                  doc.data().Votes.toString() == undefined
                    ? ""
                    : doc.data().Votes.toString()
                ).trim();
                datarow.push(Votes.toString());
                //--------------------------------------------------------------------------------
                console.log(UserFullName.trim());
                if (
                  LocalQnAData.indexOf(
                    doc.data().UserFullName.toString().trim()
                  ) < 0
                ) {
                  LocalQnAData.push(datarow);
                }
              }
            });
            // console.log("LocalQnAData:- " + LocalQnAData);
            let disQnAData = LocalQnAData.filter(
              (item1, ii, ar) => ar.indexOf(item1) == ii
            );
            //console.log("disQnAData" + disQnAData);
            let csvContent = "data:text/csv;charset=utf-8,";

            LocalQnAData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            /* var encodedUri = encodeURI(csvContent);
          window.open(encodedUri);*/
            var filename =
              "QnA_RT_" + row.TableName + "_" + row.TableId + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("id", "QnA_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();

            //}
          })
          .catch((error) => {
            alert(error);
            // console.log("Error getting documents: ", error);
          });
      });
    },
    getroundTableChats: function (roundtbaleColName, tableId) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");

      selectedRows.map((row) => {
        var roundtbaleColName =
          "OAUAT_" +
          Session_Event_Id.replace("E", "").trim() +
          "_" +
          row.TableId +
          "_rt";

        debugger;
        var clientId = ls.getSessionValueByKey("Session_Client_Id");
        var event_collectionName = ls.getSessionEventCollectionName();

        var listRef = con.eventDB
          .collection(roundtbaleColName.toString()) //"OAUAT_1591907102804_521000_rt")
          .doc("Chats");

        listRef
          .get()
          .then(function (doc) {
            if (doc.exists) {
              var allChats = doc.data().Chats;

              var datarow = [];
              // datarow.push("Date");
              var LocalchatsData = [];
              datarow.push("Date");
              datarow.push("Name");
              datarow.push("Message");
              // datarow.push("Email");

              LocalchatsData.push(datarow);
              allChats.forEach((chat) => {
                /*  var UserID = (chat.UserID.toString() == undefined
                ? ""
                : chat.UserID.toString()
              ).trim();
              datarow = [];
              var listRef2 = con.eventDB
                .collection(event_collectionName) //"OA_UAT_C1591205467009E1591206650065")
                .doc("AttendeeList")
                .collection("Attendees")
                .where("AttendeeId", "==", UserID);
              //.where("IsPublished", "==", true);
              var email = "";
              listRef2.get().then(querySnapshot => {
                querySnapshot.forEach(doc => {
                  //debugger;
                  if (UserID == doc.id) {
                    email = doc.data().Email;
                    console.log(email);
                    datarow.push(email.toString());
                  }
                });
              });*/
                datarow = [];
                debugger;
                var CreatedTime = "";
                if (chat.CreatedTime != undefined) {
                  if (chat.CreatedTime.seconds != undefined) {
                    var CreatedTime = self.getFormattedTime(
                      chat.CreatedTime.seconds
                    );
                  } else {
                    CreatedTime = "";
                  }
                } else {
                  CreatedTime = "";
                }

                // (chat.CreatedTime.seconds == undefined
                //   ? ""
                //   : self.getFormattedTime(chat.CreatedTime.seconds)
                // )
                //   .toString()
                //   .trim();
                datarow.push(CreatedTime.toString());

                var UserName = (
                  chat.UserName.toString() == undefined
                    ? ""
                    : chat.UserName.toString()
                ).trim();
                datarow.push(UserName);

                var Msg = (
                  chat.Msg.toString() == undefined
                    ? ""
                    : chat.Msg.toString()
                        .split("#")
                        .join("")
                        .split(",")
                        .join("")
                ).trim();
                datarow.push(Msg);
                LocalchatsData.push(datarow);
                /*var UserID = (chat.UserID.toString() == undefined
                ? ""
                : chat.UserID.toString()
              ).trim();
              datarow.push(UserID);*/
              });
              let csvContent = "data:text/csv;charset=utf-8,";

              LocalchatsData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              /*var encodedUri = encodeURI(csvContent);
            window.open(encodedUri);*/
              var filename =
                "chat_RT_" + "_" + row.TableName + "_" + row.TableId + ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("id", "chat_RT_" + row.TableId);

              link.setAttribute("download", filename);
              document.body.appendChild(link); // Required for FF

              link.click();
            }
          })
          .catch((error) => {
            alert(error);
            // console.log("Error getting documents: ", error);
          });
      });
    },

    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var dte = dt.getDate();
      var mnth = dt.getMonth();
      var yr = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes;
      if (minutes != "00" && parseInt(minutes) < 10) {
        minutes = "0" + minutes;
      }
      var formattedtime =
        dte.toString() +
        "/" +
        mnth.toString() +
        "/" +
        yr.toString() +
        "  " +
        hours.toString() +
        ":" +
        minutes.toString() +
        " " +
        amPM;
      //return formattedtime;
      return formattedtime;
    },
    getDefaultSettings() {
      if (!this.settingsData.DefaultSettingsLoaded) {
        this.IsDefaultSettings = true;
        this.settingsData = {
          IsAttendeeCreateTableEnabled: false,
          ShowFilter: false,
          ShowSearch: false,
          EnableGroupChat: true,
          ShowAttendeeList: true,
          ShowSpeakerList: true,
          EnableRaiseHand: false,
          AllowScreenShare: false,
          AllowRecording: false,
          AutoStartRecording: false,
          HostLegend: "Host",
          TableFullText: "TABLE FULL",
          SeatGrabText: "GRAB A SEAT",
          AllowAudienceViewText: "SPECTATE",
        };
      }
      this.roundtableSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    getSettings() {
      this.roundtableSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("roundtableManagement/saveSettings", {
          settingsData: this.settingsData,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$vs.loading.close();
        });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: "All",
            value: "all",
          };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    addRecord() {
      this.$router.push("/event/roundtable/add").catch(() => {});
    },
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("roundtableManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("roundtableManagement/fetchRoundTables");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    UploadRoundTable: function () {
      var files = document.getElementById("roundtable_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "roundtable");
    },
    deleteRecord() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        self = this;
        const { value: text } = Swal.fire({
          title:
            "Deleting the Table(s) will also delete related reports. Are you sure?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase() == "delete") {
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        }).then(function (result) {
          if (result.dismiss != null) {
          } else {
            self.deleteRecords();
          }
        });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },
    deleteRecords() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      this.$vs.loading();
      this.$store
        .dispatch("roundtableManagement/removeMultiRecords", {
          data: selectedRows,
        })
        .then((res) => {
          if (res.status == 200) {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Delete",
              text: res.message,
            });
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Delete",
              text: res.message,
            });
          }

          this.gridApi.deselectAll();
          this.$vs.loading.close();
          this.$store.dispatch("roundtableManagement/fetchRoundTables");
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    OpenPreAssignedExport() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      // console.log(selectedRows.length);
      if (selectedRows.length > 0) {
        if (selectedRows.length > 10) {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            title: "Download Reports",
            text: "Please Download report for upto 10 at a time. ",
            //accept: this.deleteRecord,
            acceptText: "OK",
          });
        } else {
          this.fetchParticipantsByTableId();
          this.fetch_user_data();
          this.popupPreAssignedExport = true;
          document.getElementById(
            "modalRoundtablePreAssignedSelected"
          ).innerText = "Roundtable(s) Selected : " + selectedRows.length;
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one roundtable to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    fetchParticipantsByTableId() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      var JoinedParticipantsData = [];
      var finalData = {};
      selectedRows.map((row) => {
        con.eventDB
          .collection(cn)
          .doc("RoundTableList")
          .collection("RoundTables")
          .doc(row.TableId)
          .collection("Participances")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data().JoinTime != null) {
                JoinedParticipantsData.push(doc.data());
              }
            });
            this.participants[row.TableId] = JoinedParticipantsData;
            JoinedParticipantsData = [];
          });
      });
    },
    exportPreAssignedTableStatus() {
      self = this;
      let selectedRows;
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        //this.popupActiveExport = true;
        var datarow = [];
        var datarow1 = [];
        var timeZone = [];
        datarow1.push("Round Table Report Generated On");
        timeZone.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"' + timezone + " Time Zone" + '"');
        datarow.push("Table Id");
        datarow.push("Table Name");
        datarow.push("Table Host");
        datarow.push("Type");
        datarow.push("Pre-assigned to");
        datarow.push("Not Logged In");
        datarow.push("Logged In");
        datarow.push("Joined Table");
        datarow.push("Yet to Join Table");
        var currentDate = new Date();
        var formatedDate =
          currentDate.toLocaleString("default", {
            month: "short",
          }) +
          " " +
          currentDate.getDate() +
          "," +
          currentDate.getFullYear() +
          " " +
          currentDate.getHours() +
          ":" +
          currentDate.getMinutes();
        datarow1.push('"' + formatedDate + '"');
        var AttendeeData = [];
        AttendeeData.push(datarow);
        var TableData = [];
        TableData.push(datarow1);
        var TimeZoneHeader = [];
        TimeZoneHeader.push(timeZone);

        selectedRows.map((row) => {
          datarow = [];
          var TableId = row.TableId == undefined ? "" : row.TableId;
          datarow.push('"' + TableId + '"');
          var TableName = row.TableName == undefined ? "" : row.TableName;
          datarow.push('"' + TableName + '"');
          var Host = row.Host.length ? row.Host[0].Name : "";
          datarow.push('"' + Host + '"');
          var Type = row.PreAssigned ? "Pre Assigned" : "Open";
          datarow.push('"' + Type + '"');
          if (row.PreAssigned) {
            var attendeeList = [];
            var notLoggedInList = [];
            var loggedInList = [];
            var joinedList = [];
            var yetToJoinList = [];
            var tempLoginList = [];
            this.loggedInUserData.map((row2) => {
              tempLoginList.push(row2.UserEmail.trim());
            });
            row.MappedAttendees.map((row1) => {
              var mappedAttendee =
                row1.Name == undefined || row1.Name == "" ? "" : row1.Name;
              attendeeList.push(mappedAttendee);
              if (tempLoginList.includes(row.Host[0].Email)) {
                loggedInList.push(row.Host[0].Name);
              } else {
                notLoggedInList.push(row.Host[0].Name);
              }
              if (tempLoginList.includes(row1.Email)) {
                loggedInList.push(row1.Name);
              } else {
                notLoggedInList.push(row1.Name);
              }
            });
            this.participants[row.TableId].map((row3) => {
              //console.log("row3=======",this.row3);
              this.loggedInUserData.map((row4) => {
                //console.log("row3====",row3)
                if (
                  row3.AttendeeId == row4.UID &&
                  row3.AttendeeType != undefined
                ) {
                  //mapped attendee who logged into the event
                  joinedList.push(row4.Uname);
                }
              });
            });
            var notJoinedParticipants = attendeeList.filter(function (obj) {
              return [...new Set(joinedList)].join(",").indexOf(obj) == -1;
            });
            datarow.push('"' + attendeeList.join(",") + '"');
            datarow.push('"' + [...new Set(notLoggedInList)].join(",") + '"');
            datarow.push('"' + [...new Set(loggedInList)].join(",") + '"');
            datarow.push('"' + [...new Set(joinedList)].join(",") + '"');
            datarow.push('"' + notJoinedParticipants.join(",") + '"');
          }
          AttendeeData.push(datarow);
          //---------------------------------------------------------
        });
        //debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TableData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        TimeZoneHeader.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "Pre-assignedTableStatus_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one roundtable to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    fetch_user_data() {
      var loggedInList = [];
      this.$store
        .dispatch("analytics/fetchUserLoginDataForReport")
        .then((res) => {
          res.data.forEach((doc) => {
            loggedInList.push(doc);
          });
          this.loggedInUserData = loggedInList;
        })
        .catch((err) => {
          console.log("error blck");
          console.error(err);
        });
    },
    downloadTheCvsFile() {
      this.$vs.loading();
      this.exportPreAssignedTableStatus();
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    getDevice: function (uastring) {
      var retVal = "";
      var result = parser(uastring);
      if (result.device != undefined) {
        if (result.device.vendor != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.device.vendor;
          if (result.device.model != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.device.model;
          }
        }
      }
      if (result.os != undefined) {
        if (result.os.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.os.name;
          if (result.os.version != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.os.version;
          }
        }
      }
      if (result.browser != undefined) {
        if (result.browser.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.browser.name;
          if (result.browser.major != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.browser.major;
          }
        }
      }
      return retVal;
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    downloadZoomReport() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      selectedRows.map((row) => {
        console.log("row======", row);
        if (row.StreamingClient == "Zoom") {
          if (row.Zoom_Detail != undefined) {
            if (row.Zoom_Detail.id != undefined) {
              this.$store
                .dispatch(
                  "sessionManagement/fetchZoomMeetingAnalytics",
                  row.Zoom_Detail.id
                )
                .then((res) => {
                  this.zoomAnalytics = res;
                  //this.$vs.loading.close();
                  if (
                    this.zoomAnalytics != undefined &&
                    this.zoomAnalytics.length > 0
                  ) {
                    this.makeZoomAnalyticsCsv(row);
                  } else {
                    // this.$vs.loading.close();
                    alert(
                      "Please download the report after the Webinar/Meeting has ended."
                    );
                  }
                })
                .catch((err) => {
                  console.error(err);
                  // this.$vs.loading.close();
                });
            } else {
              // this.$vs.loading.close();
              alert("Error in Zoom setup, please contact Support.");
              //this.$vs.loading.close();
            }
          } else {
            //this.$vs.loading.close();
            alert(
              "An unknown error occurred with Zoom, please try again in a while or contact Support"
            );
          }
        } else {
          // this.$vs.loading.close();
          alert("Report is not yet ready, please try after sometime");
        }
      });
    },
    makeZoomAnalyticsCsv(data) {
      this.$vs.loading();
      var datarow = [];
      var timeZone = [];
      var sessions = [];

      timeZone.push("Report Exported In ");
      var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
      timeZone.push('"' + timezone + " Time Zone" + '"');

      sessions.push("Session Name");
      var sessionName = data.TableName;
      sessions.push('"' + sessionName + '"');

      datarow.push("Name");
      datarow.push("Email");
      datarow.push("Join Time");
      datarow.push("Leave Time");
      datarow.push("Duration in Mins");
      var userLoginData = [];
      userLoginData.push(datarow);

      var TimeZoneHeader = [];
      TimeZoneHeader.push(timeZone);

      var SessionHeader = [];
      SessionHeader.push(sessions);

      this.zoomAnalytics.map((row1) => {
        datarow = [];
        var name = row1.name == undefined ? "" : row1.name;
        datarow.push('"' + name + '"');
        var email = row1.user_email == undefined ? "" : row1.user_email;
        datarow.push('"' + email + '"');

        var joinDate =
          row1.join_time == undefined
            ? ""
            : '"' +
              row1.join_time.slice(0, 10) +
              " " +
              row1.join_time.slice(11, 19) +
              '"';
        datarow.push(joinDate);
        var leaveDate =
          row1.leave_time == undefined
            ? ""
            : '"' +
              row1.leave_time.slice(0, 10) +
              " " +
              row1.leave_time.slice(11, 19) +
              '"';
        datarow.push(leaveDate);
        var duration =
          row1.duration == undefined
            ? ""
            : '"' + Math.floor(row1.duration / 60) + '"';
        datarow.push(duration);

        userLoginData.push(datarow);
      });
      let csvContent = "data:text/csv;charset=utf-8,";
      var dt = new Date().toISOString().slice(0, 10);
      // TimeZoneHeader.forEach(function (rowArray) {
      //   let row = rowArray.join(",");
      //   csvContent += row + "\r\n";
      // });
      SessionHeader.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      userLoginData.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var filename = "ZoomData" + "_" + sessionName + "_" + dt + ".csv";
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      //link.setAttribute("id", "Participance_RT_" + row.TableId);
      link.setAttribute("download", filename);
      document.body.appendChild(link); // Required for FF
      link.click();
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    onGridReadyTopic(params) {
      this.gridTopicApi = params.api;
    },
    saveRoundtableSettingsData() {
      this.settingsData = {
        DefaultSettingsLoaded: true,
      };
    },
  },
  mounted() {
    self = this;
    this.gridOptions.api.showLoadingOverlay();
    //this.gridOptionsTopic.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;
    //this.gridTopicApi = this.gridOptionsTopic.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleRoundtableManagement.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleRoundtableManagement
      );
      moduleRoundtableManagement.isRegistered = true;
    }
    this.$vs.loading();
    this.$store.dispatch("roundtableManagement/getSettings").then((res) => {
      this.settingsData = res;
      this.$store
        .dispatch("roundtableManagement/fetchRoundTables")
        .then((res) => {
          this.pageLoaded = true;
          this.$vs.loading.close();
        });
    });

    if (!moduleAnalytics.isRegistered) {
      this.$store.registerModule("analytics", moduleAnalytics);
      moduleAnalytics.isRegistered = true;
    }
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>